// video-interaction.js
// Keep Shopify video sources intact and play muted autoplay videos near the viewport.

(function () {
  'use strict';

  var observer;

  function restoreLegacySources(video) {
    var changed = false;

    video.querySelectorAll('source[data-src-original]').forEach(function (source) {
      if (!source.getAttribute('src') && source.dataset.srcOriginal) {
        source.setAttribute('src', source.dataset.srcOriginal);
        changed = true;
      }
      source.removeAttribute('data-src-original');
    });

    if (!video.getAttribute('src') && video.dataset.srcOriginal) {
      video.setAttribute('src', video.dataset.srcOriginal);
      changed = true;
    }

    video.removeAttribute('data-src-original');
    video.removeAttribute('data-video-gate-processed');

    if (changed) {
      try { video.load(); } catch (error) {}
    }
  }

  function playVideo(video) {
    if (!video.hasAttribute('autoplay') && video.dataset.autoplay !== 'true') return;

    video.muted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');

    try {
      var promise = video.play();
      if (promise && typeof promise.catch === 'function') {
        promise.catch(function () {});
      }
    } catch (error) {}
  }

  function prepareVideo(video) {
    if (!video || video.dataset.videoInteractionReady === 'true') return;

    restoreLegacySources(video);
    video.dataset.videoInteractionReady = 'true';

    if (observer) {
      observer.observe(video);
    } else {
      playVideo(video);
    }
  }

  function prepareTree(root) {
    if (!root || root.nodeType !== 1) return;

    if (root.tagName === 'VIDEO') {
      prepareVideo(root);
    } else if (root.querySelectorAll) {
      root.querySelectorAll('video').forEach(prepareVideo);
    }
  }

  function init() {
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            playVideo(entry.target);
          } else {
            entry.target.pause();
          }
        });
      }, {
        rootMargin: '250px 0px',
        threshold: 0.01
      });
    }

    document.querySelectorAll('video').forEach(prepareVideo);

    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(prepareTree);
        });
      }).observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
